import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PAGES, type PageLabel, type PageRoute } from '../pages/pages.constants';

export default function useActivePage(defaultPage: { label: PageLabel; route: PageRoute }) {
  const { pathname } = useLocation();
  const [activePage, setActivePage] = useState(defaultPage);

  useEffect(() => {
    const currentBasePath = Object.keys(PAGES).find((link) => pathname.includes(link.slice(0, -1)));
    const route = (currentBasePath || defaultPage.route) as PageRoute;
    const label = PAGES[route];

    setActivePage({ route, label });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return activePage;
}
